import { render, staticRenderFns } from "./payView.vue?vue&type=template&id=b034c856&scoped=true"
import script from "./payView.vue?vue&type=script&lang=js"
export * from "./payView.vue?vue&type=script&lang=js"
import style0 from "./payView.vue?vue&type=style&index=0&id=b034c856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b034c856",
  null
  
)

export default component.exports